<template>
  <header class="header">
    <div class="container">
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div>
          <hospital-header class="header-hospital" v-if="isHospital"></hospital-header>
        </div>
        <div>
          <subscription-info
            class="text-important"
            v-if="isSubsEnd"
            :dateSubscription="dateSubscription"
          ></subscription-info>
        </div>
        <div v-if="$i18n" class="d-flex flex-row">
          <div class="d-flex align-items-center">
            <LanguageSwitcher class="d-inline-block mr-2" />
          </div>
          <span style="border-right: 2px solid #CCD0D1; margin: 7px 15px"></span>
          <div v-if="user" class="text-right">
            <dropdown :withArrow="false" :isLarge="true">
              <template #buttonText>
                <div class="header-user">
                  <h3 class="title header-user__name">{{ fullName }}</h3>
                  <span class="icon icon-authorized icon_dark"></span>
                </div>
              </template>
              <template #dropdownContent>
                <user-card :user="user"></user-card>
              </template>
            </dropdown>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import HospitalHeader from '@/components/HospitalHeader.vue'
import '@/styles/components/header.less'
import http from '@/modules/http.js'
import { nowMoment } from '@/mixins/now-moment'
import { userRights } from '@/mixins/user-rights.js'

export default {
  name: 'HeaderBody',
  components: {
    HospitalHeader: HospitalHeader,
    UserCard: () => import('@/components/UserCard.vue'),
    Dropdown: () => import('@/base/BaseDropdown.vue'),
    LanguageSwitcher: () => import('@/components/LanguageSwitcher.vue'),
    SubscriptionInfo: () => import('@/components/SubscriptionInfo.vue')
  },
  mixins: [nowMoment, userRights],
  data: () => ({
    hospital: null
  }),
  mounted() {
    this.getHospital()
  },
  computed: {
    isHospital() {
      if (this.$store.getters.HAS_NEURO_ADMIN) {
        return !!this.$route.query.hospital
      } else {
        return true
      }
    },
    user() {
      return this.$store.getters.AUTH_USER
    },
    fullName() {
      return this.user ? this.user.surname + ' ' + this.user.name : ''
    },
    hospitalId() {
      if (this.isNeuroAdmin) {
        return +this.$store.getters.SELECTED_HOSPITAL
      }
      if (this.$store.getters.AUTH_USER) {
        return +this.$store.getters.AUTH_USER.hospital_id
      }
      return null
    },
    dateSubscription() {
      if (this.hospital) {
        return this.hospital.date_subscription_end
      } else return null
    },
    isSubsEnd() {
      if (this.dateSubscription) {
        let momentDate = this.moment(this.dateSubscription)
        if (
          momentDate.isSameOrBefore(this.moment(this.nowMoment.format('MM/DD/YYYY')), 'day') ||
          momentDate.diff(this.moment(this.nowMoment.format('MM/DD/YYYY')), 'days') < 14
        ) {
          return true
        } else return false
      } else return false
    }
  },
  watch: {
    hospitalId() {
      this.getHospital()
    }
  },
  methods: {
    getHospital() {
      if (!this.hospitalId) {
        this.hospital = null
        return
      }

      http
        .get('/hospitals/' + this.hospitalId)
        .then(response => {
          this.hospital = response.data
          localStorage.setItem('activeHospital', response.data.is_available)
        })
        .catch(error => console.log(error))
    }
  }
}
</script>
